import { createFileRoute } from '@tanstack/react-router';
import { createGroupBroadcastDetailRoute } from '@/lib/route-factories/group-broadcast-route';

export const Route = createFileRoute(
  '/_authed/networks/$id/admin/broadcasts/$broadcastId/',
)(
  createGroupBroadcastDetailRoute({
    kind: 'network',
    fromId: '/_authed/networks/$id/admin/broadcasts/$broadcastId/',
  }),
);
